import React from 'react';

import MainController from './main.controller';

const MainScreen: React.FC = () => {
  return <MainController />;
};
export default MainScreen;
